import React from "react";
import "./Components.css";
import AppBar from "@material-ui/core/AppBar";
import { Toolbar, Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faShoppingCart,
  faPowerOff
} from "@fortawesome/free-solid-svg-icons";
import Badge from "@material-ui/core/Badge";

library.add(faSearch);
library.add(faShoppingCart, faPowerOff);

const Navbar = props => {
  return (
    <AppBar position="fixed" color="primary" className="navbar">
      <Toolbar>
        <Typography variant="h6" color="inherit">
          {props.title}
        </Typography>
        &nbsp;
        {/* <h3 className="inline">Items: {props.items}</h3> */}
        <div className="search">
          <div className="inline search-icon">
            <FontAwesomeIcon icon="search" />
          </div>
          &nbsp;
          <input
            placeholder="Search…"
            onChange={props.search}
            className="inline input-input"
          />
        </div>
        <div style={{ flexGrow: 1 }} />
        <Badge badgeContent={props.items} color="secondary">
          <FontAwesomeIcon icon="shopping-cart" />
        </Badge>
        &nbsp;
        <Button
          onClick={props.logout}
          variant="text"
          size="small"
          color="inherit"
        >
          <FontAwesomeIcon onClick={props.logout} icon="power-off" />
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
